import cn from 'bem-cn';
import { block as blockNS } from '../../cls';
import './gallery.less';

export var block = blockNS('gallery');
export var slide = block('slide');
export var slidesWrapper = block('slidesWrapper');
export var tailNS = block('tail');
export var tail = tailNS();
export var tailIcon = tailNS('icon');
export var tailArrow = tailNS('arrow')();
export var iconClass = cn('svg-icon');